import { useWallet } from "../context/WalletContext.jsx";
import config from "../config/index.js";

/**
 * Persistent banner shown whenever the connected wallet is on a chain other
 * than the configured network. Exposes a one-click switch action that adds
 * the chain via wallet_addEthereumChain if necessary.
 */
export default function NetworkBanner() {
    const { wrongChain, switchNetwork } = useWallet();
    if (!wrongChain) return null;
    return (
        <div className="bg-vb-danger/15 border-b border-vb-danger/40">
            <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-6 py-2 text-sm text-vb-danger">
                <span>
                    Wrong network. Please switch to <strong>{config.network.name}</strong> (chain id{" "}
                    {config.network.chainId}) to continue.
                </span>
                <button className="btn-danger" onClick={switchNetwork}>
                    Switch Network
                </button>
            </div>
        </div>
    );
}
